import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type ProcurementIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const ProcurementIllustration = ({ ...props }: ProcurementIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <path
      d="M50 30V14L38 2H2V62H50V50"
      fill="none"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M62 29L57 24L39 42L38 48L44 47L62 29Z"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line x1="7" y1="54" x2="45" y2="54" fill="none" strokeWidth="2" />
    <path
      d="M8.00452 50C8.00452 49.0211 7.9395 48.0759 8.3026 47.1378C9.01099 45.3078 10.3389 43.4799 11.5732 41.9056C12.3838 40.8718 13.3013 40.0091 14.2973 39.1267C14.7285 38.7447 15.3236 38.2424 15.9119 38.0743C17.2672 37.687 17.0478 38.8939 17.0877 39.8612C17.1809 42.1206 16.6033 44.3337 15.9865 46.5094C15.881 46.8814 15.6106 48.4024 16.2349 47.9556C17.2754 47.2109 18.34 46.4958 19.4061 45.7824C19.8815 45.4644 20.5707 44.8746 21.1532 44.7148C22.5477 44.3322 23.8147 44.9108 25.0282 45.3963C27.3951 46.3432 29.4426 48.4563 32 48.4563"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line x1="38" y1="3" x2="38" y2="14" fill="none" strokeWidth="2" strokeLinecap="round" />
    <line x1="49" y1="14" x2="38" y2="14" fill="none" strokeWidth="2" strokeLinecap="round" />
  </BaseIllustration>
);

ProcurementIllustration.displayName = 'ProcurementIllustration';
